import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { PageHeader } from '../components/ds/Primitives';
import EngagementLettersStorage from './EngagementLettersStorage';
import EsignTemplates from './EsignTemplates';
import { ClausesPanel } from '../components/settings/el/ClausesPanel';
import { NoCountriesBanner, OffshorePanel } from '../components/settings/el/OffshorePanel';
import { ExistingClientsPanel } from '../components/settings/el/ExistingClientsPanel';
import { elAPI } from '../lib/elAPI';
import api from '../lib/api';

// Old Settings sub-tab keys (?el=) map onto the new tabs.
const LEGACY = { existing: 'send', templates: 'templates', clauses: 'clauses', offshore: 'offshore' };
const ADMIN_TABS = ['send', 'templates', 'clauses', 'offshore'];

export default function ClientEngagements() {
  const { search } = useLocation();
  const nav = useNavigate();
  const sp = new URLSearchParams(search);
  const tab = sp.get('tab') || LEGACY[sp.get('el')] || 'engagements';
  const [role, setRole] = useState(null);
  const [meta, setMeta] = useState(null);
  useEffect(() => { api.get('/api/me').then((r) => setRole(r.data.active_membership?.role || '')).catch(() => setRole('')); }, []);
  // Same permission as the former Settings → Engagement Letters group: owners and admins only.
  const admin = ['owner', 'admin'].includes(role);
  useEffect(() => { if (admin) elAPI.offshore().then(setMeta).catch(() => {}); }, [admin]);
  const onSaved = useCallback((m) => setMeta(m), []);
  const setTab = (v) => nav(v === 'engagements' ? '/client-engagements' : `/client-engagements?tab=${v}`, { replace: true });
  const active = role === null ? 'engagements' : ADMIN_TABS.includes(tab) && !admin ? 'engagements' : tab;
  return (
    <div className="space-y-4 p-4 sm:p-6 lg:p-8" data-testid="client-engagements">
      <PageHeader title={<span data-testid="eng-storage-title">Client engagements</span>} description="Engagement letters, signing status and everything used to produce them: templates, clauses and offshore disclosures." />
      {admin && <NoCountriesBanner meta={meta} onGo={() => setTab('offshore')} />}
      <Tabs value={active} onValueChange={setTab}>
        <div className="max-w-full overflow-x-auto"><TabsList data-testid="ce-tabs">
          <TabsTrigger value="engagements" data-testid="ce-tab-engagements">Engagements</TabsTrigger>
          {admin && <TabsTrigger value="send" data-testid="ce-tab-send">Send to existing clients</TabsTrigger>}
          {admin && <TabsTrigger value="templates" data-testid="ce-tab-templates">Templates</TabsTrigger>}
          {admin && <TabsTrigger value="clauses" data-testid="ce-tab-clauses">Clauses</TabsTrigger>}
          {admin && <TabsTrigger value="offshore" data-testid="ce-tab-offshore">Offshore services</TabsTrigger>}
        </TabsList></div>
        <TabsContent value="engagements"><EngagementLettersStorage embedded /></TabsContent>
        {admin && <>
          <TabsContent value="send"><ExistingClientsPanel /></TabsContent>
          <TabsContent value="templates"><EsignTemplates embedded /></TabsContent>
          <TabsContent value="clauses"><ClausesPanel /></TabsContent>
          <TabsContent value="offshore"><OffshorePanel onSaved={onSaved} /></TabsContent>
        </>}
      </Tabs>
    </div>
  );
}
